import { Description, SuccessText } from '../VerificationCode.styles';
import React, { Fragment } from 'react';
import { Button } from '@welbe/design-system';
import { useNavigate } from 'react-router-dom';

type SuccessInfoProps = {
	loading?: boolean;
};

export const SuccessInfo = ({ loading }: SuccessInfoProps) => {
	const navigate = useNavigate();
	return (
		<Fragment>
			<Description>
				<SuccessText>¡Has completado tu registro!</SuccessText>
				<p>Te damos la bienvenida a la plataforma Welbe.</p>
			</Description>
			<Button
				width="160px"
				disabled={loading}
				onClick={() => navigate('/login')}
			>
				Seguir al login
			</Button>
		</Fragment>
	);
};
